<template>
  <VApp :theme="isDarkMode ? 'dark' : 'light'">
    <TopBar>
    </TopBar>

    <Snackbars>
    </Snackbars>

    <ConsoleSidemenu v-bind:subscriptionType="subscriptionType" v-bind:subscriptionName="subscriptionName">
    </ConsoleSidemenu>

    <PermissionsChangedDialog v-model="shouldShowPermissionsChangedDialog">
    </PermissionsChangedDialog>

    <VMain scrollable>
      <VContainer fluid class="pt-1" style="">
        <RouterView></RouterView>
      </VContainer>
    </VMain>
  </VApp>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import { useNodeStore } from '@/stores/NodeStore.js';
import { useSystemStore } from '@/stores/SystemStore.js'
import { useNotificationStore } from '@/stores/NotificationStore.js'
import TopBar from "./TopBar.vue"
import Snackbars from "../components/Snackbars.vue"
import ConsoleSidemenu from "./ConsoleSidemenu.vue"
import LayoutThemeMixin from '../components/LayoutThemeMixin.js'
import PermissionsChangedDialog from '../../routes/nodes2/components/dialogs/PermissionsChangedDialog.vue'


export default {
  name: "ConsoleLayout",
  mixins: [LayoutThemeMixin],
  components: {
    TopBar,
    Snackbars,
    ConsoleSidemenu,
    PermissionsChangedDialog,
  },
  data() {
    return {
      // shouldShowMovedNodeDialog: false,
      // shouldShowDeletedNodeDialog: false,
      shouldShowPermissionsChangedDialog: false,
    };
  },
  async created() {
    // subscribe to push notifications on created()
    // to ensure that we will catch any notificaions
    const notificationStore = useNotificationStore();
    notificationStore.subscribe();
  },
  async mounted() {
    // this.getCurrentNode;
    await this.refreshDbUser();
    this.setActiveNodeIfNeeded();

    const nodeStore = useNodeStore();
    await nodeStore.refreshAccessPoints();

    await this.refreshSubscription();
  },
  beforeUnmount: function() {
    const mainStore = useMainStore();
    mainStore.resetSnackbar();
  },
  watch: {
    /*
    getDbUser(newUser) {
      if (newUser) {
        this.refreshSubscription();
      }
    },
    */
    getActiveAccesspoint: function(accesspoint) {
      this.$updateAbilities(accesspoint?.group?.abilities || []);
    },
    async getRootNodeId(newValue, oldValue) {
      if (oldValue && newValue) {
        await this.refreshSubscription(newValue, true);
      }
    },
    getAccessPoints() {
      this.setActiveNodeIfNeeded();
    },
    getForceLogout: function(newValue) {
      if (newValue) {
        this.shouldShowPermissionsChangedDialog = newValue;
      }
    },
  },
  methods: {
    async refreshDbUser() {
      try {
        const authStore = useAuthStore();
        const user = await authStore.refreshDBUser();
        const isDarkMode = user?.settings?.theme === 'dark';

        const mainStore = useMainStore();
        if (window.localStorage.isDarkMode === undefined) {
          mainStore.setDarkMode(isDarkMode);
        }

        // if (window.localStorage.abilities) {
        //   const abilities = JSON.parse(window.localStorage.abilities);
        //   this.$ability.update(abilities);
        // }

        this.setSubscriptionTimeout();
      } catch (error) {
        console.log("ERROR:", error);
        setTimeout(() => {
          this.$router.push('/account/logout');
        }, 2000);
      }
    },
    setActiveNodeIfNeeded() {
      // When we refresh any page on the layout we are losing the active node.
      // So we set the access point as active node.
      if (!this.getCurrentNode &&
          this.getRootNodeId &&
          this.getAccessPoints &&
          this.getAccessPoints.length > 0 )
      {
        const nodeStore = useNodeStore();
        nodeStore.setActiveNode(this.getRootNodeId);
      }
    },
    async refreshSubscription(contextNodeId = this.getRootNodeId, force = false) {
      const systemStore = useSystemStore();
      const subscription = systemStore.getSubscription;

      if (force || !subscription) {
        if (contextNodeId && this.$canControlTenantConfig()) {
          await systemStore.refreshSubscription(contextNodeId, force);
        }
      }
    },
    async checkSubscription() {
      const allowedUrls = [
        '/console/index',
        '/console/subscription',
        '/console/subscription-plans'
      ];

      // Check if the subscription is still valid
      if (this.isTenantExpired && !allowedUrls.includes(this.$route.path)) {
        this.$router.push('/account/tenant-expired');
      }
    },
    setSubscriptionTimeout: function() {
      // Sets a timeout function to check if the subscription is still valid
      const authStore = useAuthStore();
      const expireTS = authStore.subscriptionExpireTimestamp;

      if (!expireTS) {
        return;
      }

      const maxTimeout = 2147483647; // 32-bit signied int, otherwise overflows
      const waitTime = Math.min(expireTS, maxTimeout);

      this.subscriptionTimeoutID = setTimeout(this.checkSubscription, waitTime);
    },
  },
  computed: {
    getDbUser() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    getActiveAccesspoint() {
      const authStore = useAuthStore();
      return authStore.getActiveAccesspoint;
    },
    getAccessPoints() {
      const nodeStore = useNodeStore();
      return nodeStore.getAccessPoints;
    },
    getRootNodeId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    getCurrentNode: function() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    isTenantExpired: function() {
      const authStore = useAuthStore();
      return authStore.tenantIsExpired;
    },
    subscriptionType: function() {
      const authStore = useAuthStore();
      const activeTenant = authStore.getActiveTenant;

      if (activeTenant?.subscription?.subscriptionType) {
        return activeTenant.subscription.subscriptionType;
      }

      return 'enterprise';
    },
    subscriptionName() {
      const systemStore = useSystemStore();
      const getSubscription = systemStore.getSubscription;

      return getSubscription?.subscription?.name || '';
    },
    getForceLogout: function() {
      const authStore = useAuthStore();
      return authStore.forceLogout;
    },
  },
}
</script>

<style>
</style>
